import { useEffect } from 'react';

/**
 * XeroRedirect Component
 * Redirects to Node.js API /xero/auth for Xero OAuth flow
 * Handles /xero route by redirecting to Node.js API OAuth flow
 */
const XeroRedirect = () => {
    useEffect(() => {
        // Redirect to Node.js API for Xero OAuth
        const apiUrl = process.env.VITE_API_URL || process.env.VITE_NODE_API_URL || 'http://localhost:3000';
        window.location.href = `${apiUrl}/xero/auth`;
    }, []);

    return null;
};

export default XeroRedirect;
